import(/* webpackMode: "eager", webpackExports: ["FaqClient"] */ "/opt/buildhome/repo/app/(main)/faq/FaqClient.tsx");
